import './index.scss';
import React, { memo } from 'react';

import {FOOTER_LEAD_TEXT, FOOTER_LEAD_TEXT_COMPACT, FOOTER_URL_LINK} from "../../constants/strings";

const Footer = () => {
	return (
		<div className="footer-container">
			<span className="footer-lead footer-lead--full">{FOOTER_LEAD_TEXT}</span>
			<span className="footer-lead footer-lead--compact">{FOOTER_LEAD_TEXT_COMPACT}</span>
			<a
				href={FOOTER_URL_LINK}
				target="_blank"
				rel="noopener noreferrer"
				className="footer-tlvt-link"
			>
				<span className="footer-tlvt">tlvt</span>
			</a>
		</div>
	);
}

export default memo(Footer);
